module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-wrapper be-fixed-sidebar app-layout"
  }, [_vm._c('navbar'), _vm._v(" "), (_vm.page.sidebarOpen) ? _vm._c('sidebar') : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "be-content"
  }, [_vm._c('div', {
    class: _vm.page.adArea ? 'ad-container' : ''
  }, [_vm._c('div', {
    staticClass: "left"
  }, [_vm._c('router-view')], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "right"
  }, [(_vm.page.adArea) ? _vm._c('VerticalAd', {
    key: _vm.currentRoute,
    attrs: {
      "containerClass": ''
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.adArea) ? _vm._c('VerticalAd', {
    key: _vm.currentRoute,
    attrs: {
      "containerClass": ''
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "bottom-ad xs-p-20 xs-mb-20"
  }, [_vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84aa189c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/App.vue
// module id = 693
// module chunks = 1